<template>
  <el-dialog title="新建学员"
             :visible.sync="dialogVisible"
             width="800px"
             :close-on-click-modal="false"
             @close="handleClose"
             class="create-student-dialog">
    <el-form :model="dataForm"
             ref="formRules"
             :rules="rules"
             label-position="right"
             label-width="85px"
             size="small">
      <div class="card">

        <el-form-item label="年级"
                      prop="apply_year">
          <el-select v-model="dataForm.apply_year"
                     placeholder="请选择年级"
                     clearable>
            <el-option label="2024"
                       value="2024"></el-option>
            <el-option label="2025"
                       value="2025"></el-option>
            <el-option label="2026"
                       value="2026"></el-option>
            <el-option label="2027"
                       value="2027"></el-option>
            <el-option label="2028"
                       value="2028"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="学生姓名"
                      prop="realname">
          <el-input v-model="dataForm.realname"
                    placeholder="请输入学生姓名"
                    @blur="realnameblur"></el-input>
        </el-form-item>

        <el-form-item label="联系方式"
                      prop="phone">
          <el-input v-model="dataForm.phone"
                    placeholder="请输入手机号"
                    @blur="phoneblur">
            <template slot="prepend">手机号</template>
          </el-input>
        </el-form-item>

        <el-form-item label="">
          <el-input v-model="dataForm.wechat"
                    placeholder="请输入微信号">
            <template slot="prepend">微信号</template>
          </el-input>
        </el-form-item>

        <el-form-item label="">
          <el-input v-model="dataForm.qq"
                    placeholder="请输入QQ号">
            <template slot="prepend">Q Q 号</template>
          </el-input>
        </el-form-item>

        <el-form-item label="收货人"
                      prop="receiver">
          <el-input v-model="dataForm.receiver"
                    placeholder="请输入收货人姓名"></el-input>
        </el-form-item>

        <el-form-item label="收货号码"
                      prop="receiver_mobile">
          <el-input v-model="dataForm.receiver_mobile"
                    placeholder="请输入收货号码"></el-input>
        </el-form-item>

        <el-form-item label="详细地址"
                      prop="city">
          <div class="form-item">
            <el-select v-model="dataForm.province_name"
                       placeholder="省"
                       @change="provinceChange"
                       clearable
                       style="margin-right:16px;">
              <el-option v-for="(item,index) in $store.state.cityList"
                         :key="index"
                         :label="item.name"
                         :value="{ value: item.code, label: item.name}"></el-option>
            </el-select>
            <el-select v-model="dataForm.city_name"
                       placeholder="市"
                       clearable
                       @change="cityChange"
                       style="margin-right:16px;">
              <el-option v-for="(item,index) in cityList"
                         :key="index"
                         :label="item.name"
                         :value="{ value: item.code, label: item.name}"></el-option>
            </el-select>
            <el-select v-model="dataForm.district_name"
                       placeholder="区/县"
                       v-if="districtList.length > 1"
                       clearable>
              <el-option v-for="(item,index) in districtList"
                         :key="index"
                         :label="item.name"
                         :value="{ value: item.code, label: item.name}"></el-option>
            </el-select>
          </div>
        </el-form-item>

        <el-form-item label=""
                      prop="address">
          <el-input style="flex:1;"
                    v-model="dataForm.address"
                    placeholder="详细地址"></el-input>
        </el-form-item>

        <el-form-item label="其他备注">
          <el-input type="textarea"
                    v-model="dataForm.remark"
                    placeholder="请输入其他备注"
                    style="width:100%;"></el-input>
        </el-form-item>
      </div>
    </el-form>

    <div slot="footer"
         class="dialog-footer">
      <el-button @click="handleClose">取消</el-button>
      <el-button type="primary"
                 @click="submit('formRules', false)">新建</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { studentBasicCreate } from '@/request/api'

export default {
  name: 'CreateStudentDialog',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dataForm: {
        apply_year: '',
        realname: '',
        phone: '',
        wechat: '',
        qq: '',
        receiver: '',
        receiver_mobile: '',
        province_name: '',
        city_name: '',
        district_name: '',
        address: '',
        remark: '',
      },
      rules: {
        apply_year: [
          { required: true, message: '请选择考研年份', trigger: 'change' },
        ],
        realname: [
          { required: true, message: '请输入学生姓名', trigger: 'blur' },
        ],
        phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          {
            pattern: /^[1][3,4,5,6,7,8,9][0-9]{9}$/,
            message: '请输入正确的手机号',
          },
        ],
        receiver_mobile: [
          {
            pattern: /^[1][3,4,5,6,7,8,9][0-9]{9}$/,
            message: '请输入正确的手机号',
          },
        ],
      },
      cityList: [], // 市列表
      districtList: [], // 区/县列表
    }
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      },
    },
  },
  watch: {
    visible(val) {
      if (val) {
        this.initData()
      }
    },
  },
  methods: {
    initData() {
      // 重置表单
      this.$nextTick(() => {
        if (this.$refs.formRules) {
          this.$refs.formRules.resetFields()
        }
      })
      this.dataForm = {
        apply_year: '',
        realname: '',
        phone: '',
        wechat: '',
        qq: '',
        receiver: '',
        receiver_mobile: '',
        province_name: '',
        city_name: '',
        district_name: '',
        address: '',
        remark: '',
      }
      this.cityList = []
      this.districtList = []
      // 获取城市数据（如果 store 中没有则需调用接口）
      if (
        this.$store.state.cityList &&
        this.$store.state.cityList.length === 0
      ) {
        this.$store.dispatch('fetchCityList')
      }
    },
    provinceChange(e) {
      if (e) {
        this.cityList =
          this.$store.state.cityList.find((v) => v.code === e.value).children ||
          []
        this.dataForm.city_name = ''
        this.districtList = []
      }
    },
    cityChange(e) {
      if (e) {
        this.districtList =
          this.cityList.find((v) => v.code === e.value).children || []
        if (this.districtList.length <= 1) {
          this.dataForm.district_name = ''
        }
      }
    },
    realnameblur() {
      if (this.dataForm.realname && !this.dataForm.receiver) {
        this.dataForm.receiver = this.dataForm.realname
      }
    },
    phoneblur() {
      if (this.dataForm.phone && !this.dataForm.receiver_mobile) {
        this.dataForm.receiver_mobile = this.dataForm.phone
      }
    },
    submit(formName, isBack = false) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const params = {
            cid: localStorage.getItem('cid'),
            realname: this.dataForm.realname,
            apply_year: this.dataForm.apply_year,
            phone: this.dataForm.phone,
            wechat: this.dataForm.wechat,
            qq: this.dataForm.qq,
            receiver: this.dataForm.receiver,
            receiver_mobile: this.dataForm.receiver_mobile,
            province: this.dataForm.province_name
              ? this.dataForm.province_name.value
              : '',
            city: this.dataForm.city_name ? this.dataForm.city_name.value : '',
            district: this.dataForm.district_name
              ? this.dataForm.district_name.value
              : '',
            area: this.dataForm.province_name
              ? `${this.dataForm.province_name.label || ''}${
                  this.dataForm.city_name.label || ''
                }${this.dataForm.district_name.label || ''}`
              : '',
            address: this.dataForm.address,
            remark: this.dataForm.remark,
            // 以下为必填默认值（接口可能要求）
            is_service: 0,
            is_choose: 0,
            course_status: 1,

            products: [],
            subjects: [],
            apply_time: new Date().getTime(),
            receive_amount: '0',
            coach_need: '  ',
            service_subject_ids: '',
            watcher: '',
            teacher_ids: '',
            consult_teacher_id: null,
            last_concat_time: new Date().getTime(),
            choose_remark: '',
            refer_book: '',
            service_remark: '',
            company_normal_course_ids: '',
          }

          studentBasicCreate(params).then((res) => {
            if (res.code === 0) {
              this.$message.success('新建成功')
              this.$emit('success')
              if (!isBack) {
                this.handleClose()
              } else {
                // 保存并新建：重置表单，不清空弹窗
                this.initData()
              }
            } else {
              this.$message.error(res.msg || '新建失败')
            }
          })
        } else {
          return false
        }
      })
    },
    handleClose() {
      this.dialogVisible = false
      this.$emit('close')
    },
  },
}
</script>

<style lang="less" scoped>
.card {
  background: #fff;
  padding: 16px 24px;
  border-radius: 4px;
}
.card-title {
  font-size: 16px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 16px;
}
.line {
  height: 1px;
  background: #e4e7ed;
  margin-bottom: 20px;
}
.form-item {
  display: flex;
  flex-wrap: wrap;
}
.dialog-footer {
  text-align: right;
}
/deep/ .el-dialog__body {
  padding-bottom: 10px;
}
</style>